import type { Proposal } from '@/lib/templates/api';
import { choose, chooseConflict, type Choice, type ReviewState } from './review-decisions';
import { nextOpen } from './review-progress';

export type Decision =
  | { kind: 'choose'; key: string; choice: Choice | null }
  | { kind: 'conflict'; key: string; choice: 'keep' | 'force' | null };

export function focusAfter(
  state: ReviewState,
  proposal: Proposal,
  decision: Decision,
): { kind: 'card'; key: string } | { kind: 'primary' } | null {
  if (decision.choice === null) return { kind: 'card', key: decision.key };
  const applied =
    decision.kind === 'choose'
      ? choose(state, decision.key, decision.choice)
      : chooseConflict(state, decision.key, decision.choice);
  const next = nextOpen(applied, proposal, decision.key);
  return next === null ? { kind: 'primary' } : { kind: 'card', key: next };
}
